export function generalDashboardTitle(sectionTitle: string | undefined) {
	if (sectionTitle === 'SEPARATION_AND_CONFERENCE') {
		return 'Separação e Conferência'
	} else {
		return 'Atendimento'
	}
}
